const items = [
  { icon: 'ri-shield-check-line', label: 'Licensed & Insured', sub: 'Fully certified technicians' },
  { icon: 'ri-building-2-line', label: 'Residential & Commercial', sub: 'All property types served' },
  { icon: 'ri-flashlight-line', label: 'Fast Response Times', sub: 'Available 24/7' },
  { icon: 'ri-calendar-check-line', label: 'Reliable Scheduling', sub: 'On-time, every time' },
  { icon: 'ri-bank-card-line', label: '100% Financing Available', sub: 'Get serviced immediately' },
];

export default function TrustBar() {
  return (
    <section id="trust-bar" className="bg-[#0d1b2a] border-y border-[#00d4ff]/10 py-5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-wrap justify-center lg:justify-between gap-6">
          {items.map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#00d4ff]/10 border border-[#00d4ff]/20 shrink-0">
                <i className={`${item.icon} text-[#00d4ff] text-base`} />
              </div>
              <div>
                <p className="text-white text-sm font-semibold leading-tight">{item.label}</p>
                <p className="text-[#6b7280] text-xs mt-0.5">{item.sub}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
